// extracted by mini-css-extract-plugin
export default {"project":"ahGoWvRRuFlesGNZbzx1O","button":"I4jTC2gr08tP08FQl12ls","courses":"_39a5DPPRAyY-gYvs_QuMd1","iaPanel":"_3p4W3-UFrQz_1rs2iSpftU"};